import React from "react";
import {
  MoonLoader,
  ClipLoader,
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
} from "react-spinners";

const widgetOptions = {
  arrow: SkewLoader,
  atom: RingLoader,
  bar: BarLoader,
  barcode: ScaleLoader,
  beat: BeatLoader,
  bounce: BounceLoader,
  box: SquareLoader,
  circle: CircleLoader,
  clip: ClipLoader,
  clock: ClockLoader,
  dot: DotLoader,
  dotrow: PropagateLoader,
  dotspin: RotateLoader,
  fade: FadeLoader,
  grid: GridLoader,
  hash: HashLoader,
  moon: MoonLoader,
  ping: PuffLoader,
  propagate: PropagateLoader,
  puff: PuffLoader,
  pulse: PulseLoader,
  ring: RingLoader,
  rings: RingLoader,
  rotate: RotateLoader,
  scale: ScaleLoader,
  skew: SkewLoader,
  slack: HashLoader,
  square: SquareLoader,
  star: FadeLoader,
  sync: SyncLoader,
  typing: SyncLoader,
};

const defaultWidgetProps = {
  color: "#918264",
  size: 50,
};

export function PaneLoader({
  isNew = false,
  isLoading = true,
  text = "Chronicle",
  widget = "scale",
  widgetProps,
}) {
  if (!isLoading) return null;
  const action = isNew ? "created" : "updated";
  const displayText = `Your ${text} is being ${action}, please hold.`;

  const WidgetComponent =
    widget && widget.length > 0 ? widgetOptions[widget.toLowerCase()] : null;

  const internalProps = { ...defaultWidgetProps, ...widgetProps };
  return (
    <div className="chronos-pane-loader chronos-loader">
      <div className="chronos-loader-content">
        <div className="chronos-loader-text">
          <h3 className="chronos-loader-title">{displayText}</h3>
        </div>
        {/* Loader Widget */}
        {WidgetComponent && (
          <div
            className={[
              "chronos-loader-widget",
              `chronos-loader-widget-${widget}`,
            ].join(" ")}
          >
            <WidgetComponent loading={true} {...internalProps} />
          </div>
        )}
      </div>
    </div>
  );
}
